/** Meta Pixel base code. Checkout URLs live in components/UpsellModal.tsx. */
export const PIXEL_ID = '676572141744167'

/** Shopify variant ids, so Meta can match these events to the catalog. */
export const VARIANT_IDS = {
  kit: '49960131133682',
  braveMind: '49930211688690',
  littleEngineer: '49902595670258',
  focusLab: '49945662128370',
} as const

export const OFFER_PRICE = 27.99

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
    __metaPixelInitialized?: boolean
  }
}

/** Injects the base code. Safe to call more than once — init only ever runs once. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.__metaPixelInitialized) return
  window.__metaPixelInitialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
  window.fbq?.('track', 'ViewContent', {
    content_name: 'Calm Mornings Mega Kit',
    content_type: 'product',
    content_ids: [VARIANT_IDS.kit],
    value: OFFER_PRICE,
    currency: 'USD',
  })

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  img.alt = ''
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

